import React from "react";
import { Helmet } from "react-helmet";

function SeoHead({
  title,
  description,
  path = "",
  image = "/og/og-image.png"
}) {
  const siteUrl = "https://hookora.app";

  const fullUrl = `${siteUrl}${path}`;

  const fullImageUrl = `${siteUrl}${image}`;

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImageUrl} />

      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
}

export default SeoHead;